import { Users } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { ParticipantManagement } from "./ParticipantManagement";

export interface ParticipantsDialogProps {
  participantCount: number;
  children?: React.ReactNode;
}

export function ParticipantsDialog({
  participantCount,
  children,
}: Readonly<ParticipantsDialogProps>) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children ?? (
          <Button variant="ghost" size="sm" className="p-1">
            <div className="flex flex-row items-center space-x-1">
              <div className="text-sm">{participantCount}</div>
              <div className="p-0.5">
                <Users size={16} />
              </div>
            </div>
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Meeting Participants</DialogTitle>
        </DialogHeader>
        <ParticipantManagement />
      </DialogContent>
    </Dialog>
  );
}
